import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Select, Anchor, CheckBox } from 'wt-ui';
import { Filter } from 'grommet-icons';
import { Trans } from 'react-i18next';

import RANGES from './Ranges';

const Option = (props) => {
  const { value, selected } = props;
  return (
    <Box background="transparent" direction="row" gap="small" align="center" pad="small">
      <CheckBox tabIndex="-1" background="green" checked={selected} onChange={() => {}} />
      <Trans>{value}</Trans>
    </Box>
  );
};
Option.propTypes = {
  value: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
};

const FilterComponent = ({ options, selected, onChange }) => (
  <Select
    dropAlign={{ top: 'bottom', left: 'left' }}
    plain
    icon={false}
    multiple
    closeOnChange={false}
    placeholder="select an option..."
    valueLabel={
      <Anchor>
        <Filter size="small" />
        <Trans>Filter</Trans>
      </Anchor>
    }
    selected={selected}
    options={options}
    dropHeight="medium"
    onChange={({ selected: nextSelected }) => {
      onChange(nextSelected);
    }}
  >
    {(option, index) => <Option value={option} selected={selected.indexOf(index) !== -1} />}
  </Select>
);
FilterComponent.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  selected: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChange: PropTypes.func.isRequired,
};

const CalendarHeader = ({ range, filters, dispatch }) => {
  const onRangeSelect = (id) => () => {
    dispatch({ type: 'setRange', value: id });
  };
  return (
    <Box background="transparent" direction="row" gap="small" justify="between">
      <Box background="transparent" direction="row">
        {RANGES.map((r) => {
          const isSelected = r.id === range;
          return isSelected ? (
            <Button key={r.id} onClick={onRangeSelect(r.id)} primary>
              {r.name}
            </Button>
          ) : (
            <Button key={r.id} onClick={onRangeSelect(r.id)} primary outlined>
              {r.name}
            </Button>
          );
        })}
      </Box>

      <Box background="transparent" justify="center">
        <FilterComponent
          options={filters.map((x) => x.name)}
          selected={filters.map((x, index) => (x.selected ? index : -1))}
          onChange={(nextSelected) => {
            dispatch({ type: 'setFilters', value: nextSelected });
          }}
        />
      </Box>
    </Box>
  );
};

export default CalendarHeader;
